<template>
<transition @enter="enterCart" @leave="leaveCart">
  <div :class="$style.container" v-if="getDeedProduct">
    <div ref="container" :class="$style.cartContainer">
      <div :class="$style.firstRow">
        <h2>Shop</h2>
        <Hamburger :open="true" @click.native="$store.dispatch('TRIGGER_CART')" />
      </div>
      <p :class="$style.description" v-html="getDeedProduct.description"></p>

      <SimpleCarousel :images="getDeedProduct.images" />

      <div :class="$style.choices">
        <OptionsChoice :content="colors" />
        <OptionsChoice :content="sizes" />
      </div>

      <div :class="$style.buyRow">
        <Cta :fill="true" @click.native="checkoutCart">buy now</Cta>
      </div>
    </div>
    <div @click="$store.dispatch('TRIGGER_CART')" ref="closer" :class="$style.closer"></div>
  </div>
</transition>
</template>

<script>
import { TweenMax, Expo } from 'gsap'
import { mapGetters } from 'vuex'
import Cta from '@/components/Cta'
import SimpleCarousel from '@/components/SimpleCarousel'
import OptionsChoice from '@/components/OptionsChoice'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Cta,
    SimpleCarousel,
    OptionsChoice,
    Hamburger
  },

  computed: {
    ...mapGetters(['getDeedProduct']),
    colors() {
      return this.getDeedProduct.options.find(v => v.name === 'Color')
    },
    sizes() {
      return this.getDeedProduct.options.find(v => v.name === 'Size')
    }
  },

  methods: {
    enterCart(el, done) {
      TweenMax.fromTo(this.$refs.container, 1.2, {
        xPercent: 100
      }, {
        xPercent: 0,
        ease: Expo.easeOut,
        onComplete: done
      })

      TweenMax.fromTo(this.$refs.closer, 1, { autoAlpha: 0 }, { autoAlpha: 1 })
    },

    leaveCart(el, done) {
      TweenMax.to(this.$refs.container, 1.2, {
        xPercent: 100,
        ease: Expo.easeIn,
        onComplete: done
      })

      TweenMax.to(this.$refs.closer, 0.4, { autoAlpha: 0 })
    },
    checkoutCart() {
      Promise.resolve(this.$store.dispatch('CHECKOUT_CART')).then((checkout) => {
        window.open(checkout.webUrl)
      })
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  @include boost-performance();
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: z-index(modal);
}

.closer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color-dark, 0.8);
  z-index: -1;
  cursor: pointer;
}

.cartContainer {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  background: $color-dark;
  box-shadow: -10px 1px 80px 1px rgba(black, 0.4);
  display: flex;
  flex-flow: column;
  padding: $standard-margin-mobile;

  @include mq(sm) {
    width: 40%;
    padding: $standard-margin;
  }
}

.choices {
  display: flex;
  justify-content: space-between;
}

.description {
  color: $color-gray-brown;
  margin: 20px 0;
}

.buyRow {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: center;
  padding: $small-margin;
}

.firstRow {
  position: relative;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
}

// .closeButton {
//   background: transparent;
//   border: 0;
//   cursor: pointer;
//   transition: all 0.2 ease-out;

//   :global(.no-touchevents) &:hover {
//     opacity: 0.5;
//   }

//   &:focus {
//     outline: 0;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue